import { render, staticRenderFns } from "./InventoryTransaction.vue?vue&type=template&id=99d04b50"
import script from "./InventoryTransaction.vue?vue&type=script&lang=js"
export * from "./InventoryTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports